import { HttpClient } from '@angular/common/http';
import { AccountService } from '../../services/account.service';
import { SCAMP_API, SCAMP_API_RPT } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../services/account.service";
export class PTService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    getPTComColecoesFilhas(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/pt-com-colecoes/${id}`, { headers: this.account.composeHeaders() });
    }
    getPTsStatusAberto() {
        return this.http.get(`${SCAMP_API.accountApiV1}/pts-status-aberto`, { headers: this.account.composeHeaders() });
    }
    save(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/pt`, data, { headers: this.account.composeHeaders() });
    }
    getPTParaAvaliacao(id) {
        return this.http.get(`${SCAMP_API.accountApiV1}/pt-para-avaliacao/${id}`, { headers: this.account.composeHeaders() });
    }
    /*  recusarPT(data) {
         return this.http.put(`${SCAMP_API.accountApiV1}/recusar-pt`, data, {headers : this.account.composeHeaders()});
     } */
    /*  aprovarPT(data) {
         return this.http.put(`${SCAMP_API.accountApiV1}/aprovar-pt`, data, {headers : this.account.composeHeaders()});
     } */
    pesquisarptsPorPeriodo(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/pt-pesquisar-por-periodo`, data, { headers: this.account.composeHeaders() });
    }
    // Servidor de Relatórios
    getAcompanharPTs(data) {
        return this.http.post(`${SCAMP_API_RPT.accountApiV1}/pt-pesquisar-por-periodo`, data);
    }
}
PTService.ngInjectableDef = i0.defineInjectable({ factory: function PTService_Factory() { return new PTService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: PTService, providedIn: "root" });
